/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/* eslint-disable max-len */

import CascadingSelect from './CascadingSelect.vue';
import CascadingSelectEdit from './CascadingSelectEdit.vue';
import ComponentsPicker from './ComponentsPicker.vue';
import ComponentsPickerEdit from './ComponentsPickerEdit.vue';
import DatePicker from './DatePicker.vue';
import DatePickerEdit from './DatePickerEdit.vue';
import DateTime from './DateTime.vue';
import DateTimeEdit from './DateTimeEdit.vue';
import Float from './Float.vue';
import FloatEdit from './FloatEdit.vue';
import GhSprint from './GhSprint.vue';
import IssueType from './IssueType.vue';
import Labels from './Labels.vue';
import LabelsEdit from './LabelsEdit.vue';
import MultiCheckboxes from './MultiCheckboxes.vue';
import MultiCheckboxesEdit from './MultiCheckboxesEdit.vue';
import MultiSelect from './MultiSelect.vue';
import MultiSelectEdit from './MultiSelectEdit.vue';
import NotSupportedEdit from './NotSupportedEdit.vue';
import Priority from './Priority.vue';
import PriorityEdit from './PriorityEdit.vue';
import RadioButtons from './RadioButtons.vue';
import RadioButtonsEdit from './RadioButtonsEdit.vue';
import Resolution from './Resolution.vue';
import Select from './Select.vue';
import SelectEdit from './SelectEdit.vue';
import Status from './Status.vue';
import Summary from './Summary.vue';
import SummaryEdit from './SummaryEdit.vue';
import Textarea from './Textarea.vue';
import TextareaEdit from './TextareaEdit.vue';
import TextField from './TextField.vue';
import TextFieldEdit from './TextFieldEdit.vue';
import Url from './Url.vue';
import UrlEdit from './UrlEdit.vue';
import UserPicker from './UserPicker.vue';
import UserPickerEdit from './UserPickerEdit.vue';
import Votes from './Votes.vue';
import Watches from './Watches.vue';

const systemFieldsComponents = {
  summary: [Summary, SummaryEdit],
  labels: [Labels, LabelsEdit],
  status: Status,
  issuetype: IssueType,
  priority: [Priority, PriorityEdit],
  resolution: Resolution,
  duedate: [DatePicker, DatePickerEdit],
  created: DateTime,
  updated: DateTime,
  resolutiondate: DateTime,
  assignee: [UserPicker, UserPickerEdit],
  reporter: [UserPicker, UserPickerEdit],
  components: [ComponentsPicker, ComponentsPickerEdit],
  votes: Votes,
  watches: Watches,
  description: [Textarea, TextareaEdit],
};

const customFieldsComponents = {
  'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes': [MultiCheckboxes, MultiCheckboxesEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:datepicker': [DatePicker, DatePickerEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:datetime': [DateTime, DateTimeEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:labels': [Labels, LabelsEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:float': [Float, FloatEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons': [RadioButtons, RadioButtonsEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect': [CascadingSelect, CascadingSelectEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:multiselect': [MultiSelect, MultiSelectEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:select': [Select, SelectEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:textarea': [Textarea, TextareaEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:textfield': [TextField, TextFieldEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:url': [Url, UrlEdit],
  'com.atlassian.jira.plugin.system.customfieldtypes:userpicker': [UserPicker, UserPickerEdit],

  'com.pyxis.greenhopper.jira:gh-sprint': [GhSprint, NotSupportedEdit],
  'com.pyxis.greenhopper.jira:gh-epic-link': [TextField, NotSupportedEdit],
  'com.pyxis.greenhopper.jira:gh-epic-label': [TextField, NotSupportedEdit],
  'com.pyxis.greenhopper.jira:gh-epic-color': [TextField, NotSupportedEdit],
};

/* eslint-disable complexity */
export function getFieldComponent(field, isEditing) {
  let component = null;

  if (field.schema.system && systemFieldsComponents.hasOwnProperty(field.schema.system)) {
    component = systemFieldsComponents[field.schema.system];
  } else if (field.schema.custom && customFieldsComponents.hasOwnProperty(field.schema.custom)) {
    component = customFieldsComponents[field.schema.custom];
  }

  if (component == null) {
    return null;
  }

  if (component.length !== undefined) {
    component = isEditing ? component[1] : component[0];
  }

  return component;
}
